import { render, staticRenderFns } from "./AgentPointsList.vue?vue&type=template&id=4ba14f1a&"
import script from "./AgentPointsList.vue?vue&type=script&lang=js&"
export * from "./AgentPointsList.vue?vue&type=script&lang=js&"
import style0 from "./AgentPointsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports